export const createAsyncActionTypes = baseAction => ({
  START: `${baseAction}.START`,
  SUCCESS: `${baseAction}.SUCCESS`,
  ERROR: `${baseAction}.ERROR`,
  CLEAR: `${baseAction}.CLEAR`,
  BASE: baseAction,
});
